"use strict";
/* eslint-disable import/prefer-default-export, camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockGetAssignedContentItems = exports.mockGetLessonFilters = exports.mockGetCareerJourneys = exports.mockAssignLessons = exports.mockCareerJourneyInfo = exports.mockGetUserAssignedContent = exports.mockGetAudiences = exports.mockUserInfo = exports.mockGetAdminCourses = void 0;
var interfaces_1 = require("../interfaces");
exports.mockGetAdminCourses = {
    success: true,
    courses: [
        {
            uuid: 'af25c2e8-6ae8-4296-802d-e5acd5976d37',
            displayName: 'hsadkjlalsfdhjlsdf',
            description: 'dsf;sd[]flsdf',
            isCustom: false,
            numberOfLessons: 2,
            publishedAt: '2023-02-06T06:46:58.000Z',
            iconUrl: null,
            totalDuration: 5,
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '5adeda29-7ec0-4bee-a1fe-7937c381e8e0',
            displayName: 'HTTP Security Principles',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            isCustom: false,
            numberOfLessons: 9,
            publishedAt: '2020-05-07T10:57:09.000Z',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/http.png',
            assignedBy: [],
            totalDuration: 15,
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: 'b3703b99-89d5-41a3-a033-4925e9a812d7',
            displayName: 'IaC Security',
            description: 'Learn how to secure Infrastructure as Code (IaC) platforms. ',
            isCustom: false,
            numberOfLessons: 8,
            publishedAt: '2021-12-29T10:20:42.000Z',
            totalDuration: 15,
            iconUrl: 'https://codebashing-dev-content.s3-eu-west-1.amazonaws.com/courses-assets/course_logo_iac.svg',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '3be5f89c-341d-48ca-bae8-8c28cbb3b4d9',
            displayName: 'iOS',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            isCustom: false,
            numberOfLessons: 8,
            publishedAt: '2020-05-07T10:57:08.000Z',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/ios.png',
            assignedBy: [],
            totalDuration: 25,
            userProgress: {
                total: 3,
                notStarted: 3,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '23577758-4095-4478-abf3-dd956961fa50',
            displayName: 'Java',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            isCustom: false,
            numberOfLessons: 22,
            totalDuration: 25,
            publishedAt: '2020-05-07T10:13:31.000Z',
            iconUrl: 'https://content.devcodebashing.com/courses-assets/java.png',
            assignedBy: [],
            userProgress: {
                total: 23,
                notStarted: 21,
                started: 2,
                completed: 0,
            },
        },
        {
            uuid: '56b0fb4b-83d6-40a2-85de-3e72a956e668',
            displayName: 'Java - API Security',
            description: 'Learn about the OWASP API Security Top 10 - covering all aspects, including the vulnerabilities, why they exist, exploits, and defenses.',
            isCustom: false,
            numberOfLessons: 8,
            publishedAt: '2020-12-22T15:14:55.000Z',
            iconUrl: 'https://management.devcodebashing.com/assets/v2/content/courses/java/java-249f6be8c3a23c02c7b6bc41839622a0ef0b1404b154868960a12856ac83cd70.png',
            assignedBy: [],
            totalDuration: 25,
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '4a99a0ac-5be7-4898-8e1d-4bfbcb7333e6',
            displayName: 'Java Advanced',
            description: 'Learn how to secure Java web applications and practice recognizing different attacks.',
            isCustom: false,
            numberOfLessons: 10,
            totalDuration: 25,
            publishedAt: '2020-05-07T11:28:46.000Z',
            iconUrl: 'https://codebashing-dev-content.s3.eu-west-1.amazonaws.com/courses-assets/Java_Advanced_1_Course_Icon.svg',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '9a68039b-55c6-4c9c-87e3-3f97c0f6c4ac',
            displayName: 'Java Advanced 2',
            description: 'Learn how to secure Java web applications and practice recognizing different attacks.',
            isCustom: false,
            totalDuration: 25,
            numberOfLessons: 10,
            publishedAt: '2021-02-17T17:09:48.000Z',
            iconUrl: 'https://codebashing-dev-content.s3.eu-west-1.amazonaws.com/courses-assets/Java_Advanced_2_Course_Icon.svg',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: 'a2913908-5694-4eb1-8718-46fa5b1ded9e',
            displayName: 'java custom',
            description: 'java custom desc',
            isCustom: true,
            totalDuration: 25,
            numberOfLessons: 3,
            publishedAt: '2023-05-15T07:47:26.000Z',
            iconUrl: 'https://codebashing-dev-frontend.s3.eu-west-1.amazonaws.com/platform-ui-spa/icons/customCourses/customCourse-10.svg',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '5f208a3e-e1c0-41d6-94db-a29febed3c8e',
            displayName: 'Java: Backend Security Basics',
            description: 'Learn about the OWASP Top 10 covering all aspects including the vulnerability, why it happens, exploits and defenses.',
            isCustom: false,
            totalDuration: 25,
            numberOfLessons: 19,
            publishedAt: '2020-05-07T10:57:10.000Z',
            iconUrl: null,
            assignedBy: [],
            userProgress: {
                total: 3,
                notStarted: 1,
                started: 2,
                completed: 0,
            },
        },
    ],
    total: 63,
    unAssignedTotal: 43,
    assignedTotal: 20,
};
exports.mockUserInfo = {
    user: {
        uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
        email: 'test@test.com',
        nickname: '"+alert(5)+"aaa',
        confirmedOn: '2023-04-03T12:04:19.000Z',
        profilePicture: null,
        teams: [],
        points: 11443,
        overallProgress: 0,
    },
    assignedContent: [
        {
            name: '.NET Advanced',
            contentType: 'course',
            uuid: '66a71a0b-929d-4872-be0e-54ac775e0cd9',
            numberOfItems: 10,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-26T07:15:18.000Z',
            percent: 30,
        },
        {
            name: '.NET - API Security',
            contentType: 'course',
            uuid: '42382720-e474-4765-afdc-536d8d586389',
            numberOfItems: 8,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-25T11:02:15.000Z',
            percent: 22,
        },
        {
            name: 'SQL Injection',
            contentType: 'lesson',
            uuid: '6167f23fc27d3db2e6952a04',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:43.000Z',
            percent: 0,
        },
        {
            name: 'XXE Processing',
            contentType: 'lesson',
            uuid: '6167f2408df887dad076a616',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:43.000Z',
            percent: 0,
        },
        {
            name: 'Session Fixation',
            contentType: 'lesson',
            uuid: '6167f23f8df88728e476a610',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:43.000Z',
            percent: 8,
        },
        {
            name: 'Command Injection',
            contentType: 'lesson',
            uuid: '6167f23bc27d3d92df9529f5',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:43.000Z',
            percent: 0,
        },
        {
            name: 'Reflected XSS',
            contentType: 'lesson',
            uuid: '6167f23ec27d3d4f8d952a01',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:43.000Z',
            percent: 100,
        },
        {
            name: 'Stored (Persistent) XSS',
            contentType: 'lesson',
            uuid: '6167f23f2479f1d557d557e3',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Directory (Path) Traversal',
            contentType: 'lesson',
            uuid: '6167f23c2479f12101d557d7',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Privileged Interface Exposure',
            contentType: 'lesson',
            uuid: '6167f23e8df887fa6176a60d',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Leftover Debug Code',
            contentType: 'lesson',
            uuid: '6167f23e2479f15231d557dd',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Authentication Credentials In URL',
            contentType: 'lesson',
            uuid: '6167f23a2479f14e4cd557d1',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Session Exposure Within URL',
            contentType: 'lesson',
            uuid: '6167f23f2479f1ecb9d557e0',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'User Enumeration',
            contentType: 'lesson',
            uuid: '6167f240c27d3d5d85952a07',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Horizontal Privilege Escalation',
            contentType: 'lesson',
            uuid: '6167f23dc27d3d218a9529fb',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Vertical Privilege Escalation',
            contentType: 'lesson',
            uuid: '6167f2402479f1f94dd557e6',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Cross Site Request Forgery (POST)',
            contentType: 'lesson',
            uuid: '6167f23cc27d3db1409529f8',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Click Jacking',
            contentType: 'lesson',
            uuid: '6167f23b8df887b6da76a601',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Insecure URL Redirect',
            contentType: 'lesson',
            uuid: '6167f23ec27d3d9d679529fe',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'Insecure TLS Validation',
            contentType: 'lesson',
            uuid: '6167f23d8df887783976a60a',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:45.000Z',
            percent: 0,
        },
        {
            name: 'Insecure Object Deserialization',
            contentType: 'lesson',
            uuid: '6167f23d2479f10114d557da',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:45.000Z',
            percent: 0,
        },
        {
            name: 'Vulnerable and Outdated Components',
            contentType: 'lesson',
            uuid: '6167f23b2479f1f9d0d557d4',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:45.000Z',
            percent: 0,
        },
        {
            name: 'Use of Insufficiently Random Values',
            contentType: 'lesson',
            uuid: '6167f2408df8872a0e76a613',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:43.000Z',
            percent: 0,
        },
        {
            name: 'DOM XSS',
            contentType: 'lesson',
            uuid: '6167f23c8df887633876a607',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:44.000Z',
            percent: 0,
        },
        {
            name: 'SQL Injection',
            contentType: 'lesson',
            uuid: '6167f2308df887809a76a5e3',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:45.000Z',
            percent: 0,
        },
        {
            name: 'Interface Tour',
            contentType: 'lesson',
            uuid: '6167f2152479f1739ad55759',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-11T14:39:45.000Z',
            percent: 0,
        },
        {
            name: ' Command Injection',
            contentType: 'lesson',
            uuid: '6167f207c27d3da0e395294a',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-25T21:07:56.000Z',
            percent: 0,
        },
        {
            name: ' Identification and Authentication Failures',
            contentType: 'lesson',
            uuid: '6167f1ffc27d3df88a952935',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-25T21:14:09.000Z',
            percent: 0,
        },
        {
            name: ' Command Injections',
            contentType: 'lesson',
            uuid: '64abe5fbb51cd23955827d90',
            numberOfItems: 1,
            isPrimary: false,
            status: 'not_started',
            dueDate: null,
            assignedOn: '2023-12-25T21:26:57.000Z',
            percent: 0,
        },
    ],
};
exports.mockGetAudiences = {
    success: true,
    users: [
        {
            uuid: '1553bd34-ea89-43a3-9763-7657f6b2c047',
            email: 'test@test.com',
            nickname: 'Anna',
            role: 'user',
            teams: [],
            primaryItems: [
                {
                    name: '.NET Advanced',
                    contentType: 'course',
                    uuid: '66a71a0b-929d-4872-be0e-54ac775e0cd9',
                },
            ],
            additionalItems: [],
            userProgress: {
                percent: 0,
                numberOfItems: 10,
            },
        },
        {
            uuid: '67309216-5d88-4af0-aab0-fe6da92ec64c',
            email: 'another-test@mailinator.com',
            nickname: 'another-test',
            role: 'user',
            teams: [],
            primaryItems: [
                {
                    name: '.NET Advanced',
                    contentType: 'course',
                    uuid: '66a71a0b-929d-4872-be0e-54ac775e0cd9',
                },
            ],
            additionalItems: [
                {
                    name: '.NET - API Security',
                    contentType: 'course',
                    uuid: '42382720-e474-4765-afdc-536d8d586389',
                },
            ],
            userProgress: {
                percent: 0,
                numberOfItems: 18,
            },
        },
        {
            uuid: '99522f17-d8c6-4517-b11f-edbd5b9a6a7b',
            email: 'test@test.com',
            nickname: 'nickname',
            role: 'admin',
            teams: [],
            primaryItems: [
                {
                    name: '.NET Advanced',
                    contentType: 'course',
                    uuid: '66a71a0b-929d-4872-be0e-54ac775e0cd9',
                },
            ],
            additionalItems: [
                {
                    name: '.NET - API Security',
                    contentType: 'course',
                    uuid: '42382720-e474-4765-afdc-536d8d586389',
                },
                {
                    name: 'SQL Injection',
                    contentType: 'lesson',
                    uuid: '6167f23fc27d3db2e6952a04',
                },
                {
                    name: 'XXE Processing',
                    contentType: 'lesson',
                    uuid: '6167f2408df887dad076a616',
                },
                {
                    name: 'Session Fixation',
                    contentType: 'lesson',
                    uuid: '6167f23f8df88728e476a610',
                },
                {
                    name: 'Command Injection',
                    contentType: 'lesson',
                    uuid: '6167f23bc27d3d92df9529f5',
                },
                {
                    name: 'Reflected XSS',
                    contentType: 'lesson',
                    uuid: '6167f23ec27d3d4f8d952a01',
                },
                {
                    name: 'Stored (Persistent) XSS',
                    contentType: 'lesson',
                    uuid: '6167f23f2479f1d557d557e3',
                },
                {
                    name: 'Directory (Path) Traversal',
                    contentType: 'lesson',
                    uuid: '6167f23c2479f12101d557d7',
                },
                {
                    name: 'Privileged Interface Exposure',
                    contentType: 'lesson',
                    uuid: '6167f23e8df887fa6176a60d',
                },
                {
                    name: 'Leftover Debug Code',
                    contentType: 'lesson',
                    uuid: '6167f23e2479f15231d557dd',
                },
                {
                    name: 'Authentication Credentials In URL',
                    contentType: 'lesson',
                    uuid: '6167f23a2479f14e4cd557d1',
                },
                {
                    name: 'Session Exposure Within URL',
                    contentType: 'lesson',
                    uuid: '6167f23f2479f1ecb9d557e0',
                },
                {
                    name: 'User Enumeration',
                    contentType: 'lesson',
                    uuid: '6167f240c27d3d5d85952a07',
                },
                {
                    name: 'Horizontal Privilege Escalation',
                    contentType: 'lesson',
                    uuid: '6167f23dc27d3d218a9529fb',
                },
                {
                    name: 'Vertical Privilege Escalation',
                    contentType: 'lesson',
                    uuid: '6167f2402479f1f94dd557e6',
                },
                {
                    name: 'Cross Site Request Forgery (POST)',
                    contentType: 'lesson',
                    uuid: '6167f23cc27d3db1409529f8',
                },
                {
                    name: 'Click Jacking',
                    contentType: 'lesson',
                    uuid: '6167f23b8df887b6da76a601',
                },
                {
                    name: 'Insecure URL Redirect',
                    contentType: 'lesson',
                    uuid: '6167f23ec27d3d9d679529fe',
                },
                {
                    name: 'Insecure TLS Validation',
                    contentType: 'lesson',
                    uuid: '6167f23d8df887783976a60a',
                },
                {
                    name: 'Insecure Object Deserialization',
                    contentType: 'lesson',
                    uuid: '6167f23d2479f10114d557da',
                },
                {
                    name: 'Vulnerable and Outdated Components',
                    contentType: 'lesson',
                    uuid: '6167f23b2479f1f9d0d557d4',
                },
                {
                    name: 'Use of Insufficiently Random Values',
                    contentType: 'lesson',
                    uuid: '6167f2408df8872a0e76a613',
                },
                {
                    name: 'DOM XSS',
                    contentType: 'lesson',
                    uuid: '6167f23c8df887633876a607',
                },
                {
                    name: 'SQL Injection',
                    contentType: 'lesson',
                    uuid: '6167f2308df887809a76a5e3',
                },
                {
                    name: 'Interface Tour',
                    contentType: 'lesson',
                    uuid: '6167f2152479f1739ad55759',
                },
                {
                    name: ' Command Injection',
                    contentType: 'lesson',
                    uuid: '6167f207c27d3da0e395294a',
                },
                {
                    name: ' Identification and Authentication Failures',
                    contentType: 'lesson',
                    uuid: '6167f1ffc27d3df88a952935',
                },
                {
                    name: ' Command Injections',
                    contentType: 'lesson',
                    uuid: '64abe5fbb51cd23955827d90',
                },
            ],
            userProgress: {
                percent: 0,
                numberOfItems: 45,
            },
        },
        {
            uuid: 'be83a076-f2e1-49fd-a753-82c6e128a8c8',
            email: 'arie.belenky@gmail.com',
            nickname: 'User12111011',
            role: 'user',
            teams: [],
            primaryItems: [
                {
                    name: '.NET Advanced',
                    contentType: 'course',
                    uuid: '66a71a0b-929d-4872-be0e-54ac775e0cd9',
                },
            ],
            additionalItems: [],
            userProgress: {
                percent: 0,
                numberOfItems: 10,
            },
        },
        {
            uuid: 'b614df63-7ba7-4941-ba06-bc2c217f0906',
            email: 'cccc@mailinator.com',
            nickname: 'BenKolin',
            role: 'admin',
            teams: [],
            primaryItems: [
                {
                    name: '.NET: Backend Security Basics',
                    contentType: 'course',
                    uuid: '8f305eec-0105-487e-a8ea-d2b8958fea5e',
                },
            ],
            additionalItems: [],
            userProgress: {
                percent: 0,
                numberOfItems: 19,
            },
        },
        {
            uuid: 'a300bc8e-9cce-4be9-8bbd-00f069455ba0',
            email: 'cccc@mailinator.com',
            nickname: 'cb_dev_test',
            role: 'user',
            teams: [],
            primaryItems: [
                {
                    name: '.NET: Backend Security Basics',
                    contentType: 'course',
                    uuid: '8f305eec-0105-487e-a8ea-d2b8958fea5e',
                },
            ],
            additionalItems: [
                {
                    name: '.NET',
                    contentType: 'course',
                    uuid: '760fc927-9b0d-4832-ac40-35789f9c2f25',
                },
                {
                    name: 'SQL Injection',
                    contentType: 'lesson',
                    uuid: '6167f23fc27d3db2e6952a04',
                },
                {
                    name: 'XXE Processing',
                    contentType: 'lesson',
                    uuid: '6167f2408df887dad076a616',
                },
                {
                    name: 'Command Injection',
                    contentType: 'lesson',
                    uuid: '6167f23bc27d3d92df9529f5',
                },
                {
                    name: 'Session Fixation',
                    contentType: 'lesson',
                    uuid: '6167f23f8df88728e476a610',
                },
                {
                    name: 'Reflected XSS',
                    contentType: 'lesson',
                    uuid: '6167f23ec27d3d4f8d952a01',
                },
                {
                    name: 'Stored (Persistent) XSS',
                    contentType: 'lesson',
                    uuid: '6167f23f2479f1d557d557e3',
                },
                {
                    name: 'Directory (Path) Traversal',
                    contentType: 'lesson',
                    uuid: '6167f23c2479f12101d557d7',
                },
                {
                    name: 'Privileged Interface Exposure',
                    contentType: 'lesson',
                    uuid: '6167f23e8df887fa6176a60d',
                },
                {
                    name: 'Leftover Debug Code',
                    contentType: 'lesson',
                    uuid: '6167f23e2479f15231d557dd',
                },
                {
                    name: 'Authentication Credentials In URL',
                    contentType: 'lesson',
                    uuid: '6167f23a2479f14e4cd557d1',
                },
                {
                    name: 'Session Exposure Within URL',
                    contentType: 'lesson',
                    uuid: '6167f23f2479f1ecb9d557e0',
                },
                {
                    name: 'User Enumeration',
                    contentType: 'lesson',
                    uuid: '6167f240c27d3d5d85952a07',
                },
                {
                    name: 'Horizontal Privilege Escalation',
                    contentType: 'lesson',
                    uuid: '6167f23dc27d3d218a9529fb',
                },
                {
                    name: 'Vertical Privilege Escalation',
                    contentType: 'lesson',
                    uuid: '6167f2402479f1f94dd557e6',
                },
                {
                    name: 'Cross Site Request Forgery (POST)',
                    contentType: 'lesson',
                    uuid: '6167f23cc27d3db1409529f8',
                },
                {
                    name: 'Click Jacking',
                    contentType: 'lesson',
                    uuid: '6167f23b8df887b6da76a601',
                },
                {
                    name: 'Insecure URL Redirect',
                    contentType: 'lesson',
                    uuid: '6167f23ec27d3d9d679529fe',
                },
                {
                    name: 'Insecure TLS Validation',
                    contentType: 'lesson',
                    uuid: '6167f23d8df887783976a60a',
                },
                {
                    name: 'Insecure Object Deserialization',
                    contentType: 'lesson',
                    uuid: '6167f23d2479f10114d557da',
                },
                {
                    name: 'Vulnerable and Outdated Components',
                    contentType: 'lesson',
                    uuid: '6167f23b2479f1f9d0d557d4',
                },
                {
                    name: ' Sensitive Data Exposure',
                    contentType: 'lesson',
                    uuid: '6167f2022479f1807bd5571d',
                },
            ],
            userProgress: {
                percent: 0,
                numberOfItems: 62,
            },
        },
        {
            uuid: 'c2acf23d-11c6-4b43-9c4c-e2675634faa9',
            email: 'test@mailinator.com',
            nickname: 'System test user',
            role: 'user',
            teams: [],
            primaryItems: [
                {
                    name: '.NET',
                    contentType: 'course',
                    uuid: '760fc927-9b0d-4832-ac40-35789f9c2f25',
                },
            ],
            additionalItems: [
                {
                    name: 'SQL Injection',
                    contentType: 'lesson',
                    uuid: '6167f23fc27d3db2e6952a04',
                },
                {
                    name: 'XXE Processing',
                    contentType: 'lesson',
                    uuid: '6167f2408df887dad076a616',
                },
                {
                    name: 'Command Injection',
                    contentType: 'lesson',
                    uuid: '6167f23bc27d3d92df9529f5',
                },
                {
                    name: 'Session Fixation',
                    contentType: 'lesson',
                    uuid: '6167f23f8df88728e476a610',
                },
                {
                    name: 'Reflected XSS',
                    contentType: 'lesson',
                    uuid: '6167f23ec27d3d4f8d952a01',
                },
                {
                    name: 'Stored (Persistent) XSS',
                    contentType: 'lesson',
                    uuid: '6167f23f2479f1d557d557e3',
                },
                {
                    name: 'Directory (Path) Traversal',
                    contentType: 'lesson',
                    uuid: '6167f23c2479f12101d557d7',
                },
                {
                    name: 'Privileged Interface Exposure',
                    contentType: 'lesson',
                    uuid: '6167f23e8df887fa6176a60d',
                },
                {
                    name: 'Leftover Debug Code',
                    contentType: 'lesson',
                    uuid: '6167f23e2479f15231d557dd',
                },
                {
                    name: 'Authentication Credentials In URL',
                    contentType: 'lesson',
                    uuid: '6167f23a2479f14e4cd557d1',
                },
                {
                    name: 'Session Exposure Within URL',
                    contentType: 'lesson',
                    uuid: '6167f23f2479f1ecb9d557e0',
                },
                {
                    name: 'User Enumeration',
                    contentType: 'lesson',
                    uuid: '6167f240c27d3d5d85952a07',
                },
                {
                    name: 'Horizontal Privilege Escalation',
                    contentType: 'lesson',
                    uuid: '6167f23dc27d3d218a9529fb',
                },
                {
                    name: 'Vertical Privilege Escalation',
                    contentType: 'lesson',
                    uuid: '6167f2402479f1f94dd557e6',
                },
                {
                    name: 'Cross Site Request Forgery (POST)',
                    contentType: 'lesson',
                    uuid: '6167f23cc27d3db1409529f8',
                },
                {
                    name: 'Click Jacking',
                    contentType: 'lesson',
                    uuid: '6167f23b8df887b6da76a601',
                },
                {
                    name: 'Insecure URL Redirect',
                    contentType: 'lesson',
                    uuid: '6167f23ec27d3d9d679529fe',
                },
                {
                    name: 'Insecure TLS Validation',
                    contentType: 'lesson',
                    uuid: '6167f23d8df887783976a60a',
                },
                {
                    name: 'Insecure Object Deserialization',
                    contentType: 'lesson',
                    uuid: '6167f23d2479f10114d557da',
                },
                {
                    name: 'Vulnerable and Outdated Components',
                    contentType: 'lesson',
                    uuid: '6167f23b2479f1f9d0d557d4',
                },
            ],
            userProgress: {
                percent: 2,
                numberOfItems: 42,
            },
        },
        {
            uuid: 'a8dbbe34-4984-42b0-952a-2a4853b2f4fe',
            email: 'test@mailinator.com',
            nickname: 'System test admin',
            role: 'admin',
            teams: [],
            primaryItems: [
                {
                    name: '.NET Advanced 2',
                    contentType: 'course',
                    uuid: '69668c4b-3ddb-4c33-803a-7a9f3f476cb2',
                },
            ],
            additionalItems: [],
            userProgress: {
                percent: 0,
                numberOfItems: 10,
            },
        },
        {
            uuid: 'c086733c-e5ee-4055-9090-e807741548f6',
            email: 'cc@mailinator.com',
            nickname: 'User25185177',
            role: 'user',
            teams: [],
            primaryItems: [
                {
                    name: '.NET Advanced 2',
                    contentType: 'course',
                    uuid: '69668c4b-3ddb-4c33-803a-7a9f3f476cb2',
                },
            ],
            additionalItems: [
                {
                    name: 'Stored (Persistent) XSS',
                    contentType: 'lesson',
                    uuid: '6167f23f2479f1d557d557e3',
                },
                {
                    name: 'Directory (Path) Traversal',
                    contentType: 'lesson',
                    uuid: '6167f23c2479f12101d557d7',
                },
                {
                    name: 'DOM XSS',
                    contentType: 'lesson',
                    uuid: '6167f23c8df887633876a607',
                },
                {
                    name: 'Reflected XSS',
                    contentType: 'lesson',
                    uuid: '6167f23ec27d3d4f8d952a01',
                },
                {
                    name: 'Privileged Interface Exposure',
                    contentType: 'lesson',
                    uuid: '6167f23e8df887fa6176a60d',
                },
                {
                    name: 'SQL Injection',
                    contentType: 'lesson',
                    uuid: '6167f2308df887809a76a5e3',
                },
                {
                    name: 'Command Injection',
                    contentType: 'lesson',
                    uuid: '6167f22c2479f139b4d557a4',
                },
                {
                    name: 'Session Fixation',
                    contentType: 'lesson',
                    uuid: '6167f22f2479f1e972d557b3',
                },
                {
                    name: 'Use of Insufficiently Random Values',
                    contentType: 'lesson',
                    uuid: '6167f2302479f16fd7d557b6',
                },
                {
                    name: 'Reflected XSS',
                    contentType: 'lesson',
                    uuid: '6167f22f8df887759276a5e0',
                },
                {
                    name: 'Stored (Persistent) XSS',
                    contentType: 'lesson',
                    uuid: '6167f230c27d3d714e9529d5',
                },
                {
                    name: 'DOM XSS',
                    contentType: 'lesson',
                    uuid: '6167f22d2479f1e989d557aa',
                },
                {
                    name: 'Directory (Path) Traversal',
                    contentType: 'lesson',
                    uuid: '6167f22d8df887b39c76a5d7',
                },
                {
                    name: 'Privileged Interface Exposure',
                    contentType: 'lesson',
                    uuid: '6167f22e2479f1ae30d557b0',
                },
                {
                    name: 'Leftover Debug Code',
                    contentType: 'lesson',
                    uuid: '6167f22ec27d3d4f659529cf',
                },
                {
                    name: 'SQL Injection',
                    contentType: 'lesson',
                    uuid: '6167f23fc27d3db2e6952a04',
                },
                {
                    name: 'XXE Processing',
                    contentType: 'lesson',
                    uuid: '6167f2408df887dad076a616',
                },
                {
                    name: 'Command Injection',
                    contentType: 'lesson',
                    uuid: '6167f23bc27d3d92df9529f5',
                },
                {
                    name: 'Session Fixation',
                    contentType: 'lesson',
                    uuid: '6167f23f8df88728e476a610',
                },
                {
                    name: 'Use of Insufficiently Random Values',
                    contentType: 'lesson',
                    uuid: '6167f2408df8872a0e76a613',
                },
            ],
            userProgress: {
                percent: 0,
                numberOfItems: 30,
            },
        },
        {
            uuid: '3d0272e6-b0e2-49d7-9395-8244f91ad304',
            email: 'cccc@mailinator.com',
            nickname: 'chedv',
            role: 'user',
            teams: [],
            primaryItems: [
                {
                    name: '.NET',
                    contentType: 'course',
                    uuid: '760fc927-9b0d-4832-ac40-35789f9c2f25',
                },
            ],
            additionalItems: [
                {
                    name: 'Directory (Path) Traversal',
                    contentType: 'lesson',
                    uuid: '6167f23c2479f12101d557d7',
                },
                {
                    name: 'Reflected XSS',
                    contentType: 'lesson',
                    uuid: '6167f23ec27d3d4f8d952a01',
                },
                {
                    name: 'DOM XSS',
                    contentType: 'lesson',
                    uuid: '6167f23c8df887633876a607',
                },
                {
                    name: 'Privileged Interface Exposure',
                    contentType: 'lesson',
                    uuid: '6167f23e8df887fa6176a60d',
                },
                {
                    name: 'Stored (Persistent) XSS',
                    contentType: 'lesson',
                    uuid: '6167f23f2479f1d557d557e3',
                },
                {
                    name: 'SQL Injection',
                    contentType: 'lesson',
                    uuid: '6167f2308df887809a76a5e3',
                },
                {
                    name: 'Command Injection',
                    contentType: 'lesson',
                    uuid: '6167f22c2479f139b4d557a4',
                },
                {
                    name: 'Session Fixation',
                    contentType: 'lesson',
                    uuid: '6167f22f2479f1e972d557b3',
                },
                {
                    name: 'Use of Insufficiently Random Values',
                    contentType: 'lesson',
                    uuid: '6167f2302479f16fd7d557b6',
                },
                {
                    name: 'Reflected XSS',
                    contentType: 'lesson',
                    uuid: '6167f22f8df887759276a5e0',
                },
                {
                    name: 'Stored (Persistent) XSS',
                    contentType: 'lesson',
                    uuid: '6167f230c27d3d714e9529d5',
                },
                {
                    name: 'DOM XSS',
                    contentType: 'lesson',
                    uuid: '6167f22d2479f1e989d557aa',
                },
                {
                    name: 'Directory (Path) Traversal',
                    contentType: 'lesson',
                    uuid: '6167f22d8df887b39c76a5d7',
                },
                {
                    name: 'Privileged Interface Exposure',
                    contentType: 'lesson',
                    uuid: '6167f22e2479f1ae30d557b0',
                },
                {
                    name: 'Leftover Debug Code',
                    contentType: 'lesson',
                    uuid: '6167f22ec27d3d4f659529cf',
                },
                {
                    name: 'SQL Injection',
                    contentType: 'lesson',
                    uuid: '6167f23fc27d3db2e6952a04',
                },
                {
                    name: 'XXE Processing',
                    contentType: 'lesson',
                    uuid: '6167f2408df887dad076a616',
                },
                {
                    name: 'Command Injection',
                    contentType: 'lesson',
                    uuid: '6167f23bc27d3d92df9529f5',
                },
                {
                    name: 'Session Fixation',
                    contentType: 'lesson',
                    uuid: '6167f23f8df88728e476a610',
                },
                {
                    name: 'Use of Insufficiently Random Values',
                    contentType: 'lesson',
                    uuid: '6167f2408df8872a0e76a613',
                },
            ],
            userProgress: {
                percent: 0,
                numberOfItems: 42,
            },
        },
    ],
    total: 88,
};
exports.mockGetUserAssignedContent = {
    success: true,
    users: [
        {
            uuid: '413a3387-608e-4eca-8129-55d72c535d06',
            email: 'confirmed12@mailinator.com',
            role: 'user',
            teams: ['Manager Team'],
            assignedOn: '2023-10-26T08:05:27.000Z',
            assignedBy: null,
            percent: 0,
            profilePicture: null,
        },
        {
            uuid: '455222d2-ed37-48d6-89fc-eabe104c06f0',
            email: 'test@chetestckmarx.com',
            role: 'user',
            teams: [],
            assignedOn: '2023-11-21T10:43:46.000Z',
            assignedBy: '455222d2-ed37-48d6-89fc-eabe104c06f0',
            percent: 0,
            profilePicture: null,
        },
        {
            uuid: '07a19297-6a4d-404c-8b0c-c92109e09126',
            email: 'test@test.com',
            role: 'admin',
            teams: [],
            assignedOn: '2023-11-13T07:35:24.000Z',
            assignedBy: '07a19297-6a4d-404c-8b0c-c92109e09126',
            percent: 0,
            profilePicture: null,
        },
        {
            uuid: '27c4b00c-f3be-43fe-b255-ddc2124de3e7',
            email: 'cccc@mailinator.com',
            role: 'admin',
            teams: [],
            assignedOn: '2023-09-06T12:51:36.000Z',
            assignedBy: null,
            percent: 0,
            profilePicture: null,
        },
        {
            uuid: '493f6b87-be12-4886-87e3-1dea30e2eb23',
            email: 'cccc@mailinator.com',
            role: 'user',
            teams: ['Manager Team'],
            assignedOn: '2023-10-25T09:30:53.000Z',
            assignedBy: null,
            percent: 13,
            profilePicture: null,
        },
        {
            uuid: 'e3c3ffdc-7dcc-4d3f-86ac-97ced491c2e8',
            email: 'cccc@mailinator.com',
            role: 'user',
            teams: ['Manager Team'],
            assignedOn: '2023-10-25T09:35:48.000Z',
            assignedBy: null,
            percent: 13,
            profilePicture: null,
        },
        {
            uuid: 'c8743587-af6d-4932-89a3-c6d594a930f7',
            email: 'cccc@mailinator.com',
            role: 'user',
            teams: [],
            assignedOn: '2023-11-12T06:55:09.000Z',
            assignedBy: 'c8743587-af6d-4932-89a3-c6d594a930f7',
            percent: 0,
            profilePicture: null,
        },
        {
            uuid: 'fbb1c1ed-ceea-4658-8533-cf53f34d655a',
            email: 'test@mailinator.com',
            role: 'user',
            teams: [],
            assignedOn: '2023-11-16T10:09:23.000Z',
            assignedBy: 'fbb1c1ed-ceea-4658-8533-cf53f34d655a',
            percent: 0,
            profilePicture: null,
        },
        {
            uuid: '72571a51-6d69-46a6-9cb9-0628b4909ad9',
            email: 'test@mailinator.com',
            role: 'user',
            teams: [],
            assignedOn: '2023-10-30T13:19:07.000Z',
            assignedBy: '72571a51-6d69-46a6-9cb9-0628b4909ad9',
            percent: 0,
            profilePicture: null,
        },
        {
            uuid: 'e088b8ec-d196-4c46-9c46-b341809b1476',
            email: 'test@mailinator.com',
            role: 'user',
            teams: [],
            assignedOn: '2023-10-31T06:17:29.000Z',
            assignedBy: 'e088b8ec-d196-4c46-9c46-b341809b1476',
            percent: 0,
            profilePicture: null,
        },
    ],
    total: 23,
    userProgress: {
        total: 23,
        notStarted: 21,
        started: 2,
        completed: 0,
    },
};
exports.mockCareerJourneyInfo = {
    success: true,
    carerrJourney: {
        displayName: 'Career Development',
        description: 'Embark on a journey to enhance your career skills.',
        iconUrl: 'https://example.com/career-icon.png',
        duration: 6,
        totalItems: 3,
        ContentProgress: [
            {
                contentType: 'Video',
                uuid: 'video-123',
                displayName: 'Introduction to Career Development',
                progress: { total: 5, notStarted: 2, started: 2, completed: 1 },
            },
            {
                contentType: 'lesson',
                uuid: 'article-456',
                displayName: 'Resume Writing Tips',
                progress: { total: 3, notStarted: 1, started: 1, completed: 1 },
            },
            {
                contentType: 'lesson',
                uuid: 'quiz-789',
                displayName: 'Interview Preparation',
                progress: { total: 10, notStarted: 4, started: 3, completed: 3 },
            },
        ],
    },
};
exports.mockAssignLessons = {
    success: true,
    lessons: [
        {
            uuid: '6167f207c27d3da0e395294a',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'A Command Injection vulnerability results in the execution of arbitrary system commands on the host operating system. Command Injection attacks are possible when an application passes unsafe user-supplied data (forms, cookies, HTTP headers, etc.) to a system command. The malicious system command is run server-side with the same privileges as the application. Play and Learn...',
            hasChallenge: true,
            displayName: 'Command Injection',
            isCustom: true,
            systemCourse: '',
            customCourses: ['Custom course java', 'Custom course .net', 'Custom course python'],
            duration: '5-8',
            userProgress: {
                total: 1,
                notStarted: 1,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '64abe5fbb51cd23955827d90',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'In this lesson, you will learn about ow a Command Injection attack is used to compromise the security of a back-end application \nand how to write code more securely to protect against \nthese attacks.',
            hasChallenge: false,
            displayName: ' Command Injections',
            isCustom: false,
            systemCourse: 'OWASP: Java - API Security ',
            customCourses: [],
            duration: '5-8',
            userProgress: {
                total: 3,
                notStarted: 3,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '6167f1ffc27d3df88a952935',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'Broken authentication is a security vulnerability caused due to faulty credential management and session management functionalities. An attacker can exploit the vulnerability by bypassing the authentication mechanism or stealing the session ID to gain unauthorized access to ',
            hasChallenge: true,
            displayName: ' Identification and Authentication Failures',
            isCustom: false,
            systemCourse: 'Application Security for Decision Makers',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf'],
            duration: '5-8',
            userProgress: {
                total: 1,
                notStarted: 1,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '6167f2038df887724776a557',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'Broken authentication is a security vulnerability caused due to faulty credential management and session management functionalities. An attacker can exploit the vulnerability by bypassing the authentication mechanism or stealing the session ID to gain unauthorized access to users',
            hasChallenge: true,
            displayName: ' Identification and Authentication Failures',
            isCustom: false,
            systemCourse: 'Application Security for QA',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'appsec for qa test'],
            duration: '5-8',
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '6167f2022479f1807bd5571d',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'Sensitive data, such as personally identifiable information, business secrets, and sensitive system information, must be protected from unauthorized access. Failure to do so can lead to data breaches, data thefts, business disruption, and even legal penalties. It is best to employ appropriate security controls for protecting the data being used by the application. Play and learn...',
            hasChallenge: true,
            displayName: ' Sensitive Data Exposure',
            isCustom: false,
            systemCourse: 'Application Security for Decision Makers',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf'],
            duration: '5-8',
            userProgress: {
                total: 1,
                notStarted: 1,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '6167f227c27d3dc6929529b8',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'Secure authentication design is one of the most crucial aspects of API Security. Although this may seem obvious, it is often unclear to developers what that means, and what they should do to ensure that the authentication mechanisms in their APIs are implemented in a secure way. Play and learn…',
            hasChallenge: true,
            displayName: ' Separating Authentication',
            isCustom: false,
            systemCourse: '.NET - API Security',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf'],
            duration: '5-8',
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '6167f271c27d3d1f9b952aae',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'Source codes is a library exposing vulnerable code and its remediated counterpart. Skim through the dozens of different vulnerabilities according to your framework of choice. Review, learn and remediate your code faster.',
            hasChallenge: false,
            displayName: '.NET',
            isCustom: false,
            systemCourse: 'Source Code',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf'],
            duration: '5-8',
            userProgress: {
                total: 1,
                notStarted: 1,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '633936eed05748ff624e3121',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'test the score of a system lesson with Storyline',
            hasChallenge: false,
            displayName: 'A test lesson (miriam)',
            isCustom: false,
            systemCourse: 'Miriam testing course',
            customCourses: [],
            duration: '5-8',
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '61c43c8cf381131fc9513e57',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'Access management for object storage is complex and full of nuances. Misconfiguration of these settings can lead to different security issues, such as sensitive data exposure. Preventing this requires knowledge of the different kinds of access settings and the interactions between them. Play and Learn…',
            hasChallenge: true,
            displayName: 'Access Management',
            isCustom: false,
            systemCourse: 'course builder course name edited',
            customCourses: ['frrf', 'jhjh', 'Test manger edit', 'tet', 'sadfsadfsafdsaf', 'dd', 'test-points'],
            duration: '5-8',
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '65686076aeeb49a4225e052b',
            iconUrl: 'https://picsum.photos/200/300?random=1',
            description: 'In this lesson, we will dive into the crucial role that image registries play within Docker infrastructure. \nWe will touch upon the potential security implications of unauthorized access to Docker registries and provide insights into how to detect, prevent, and remediate such vulnerabilities. ',
            hasChallenge: true,
            displayName: 'Access to Docker Registry',
            isCustom: false,
            systemCourse: 'Docker',
            customCourses: [],
            duration: '5-8',
            userProgress: {
                total: 1,
                notStarted: 1,
                started: 0,
                completed: 0,
            },
        },
    ],
    total: 566,
    unAssignedTotal: 420,
    assignedTotal: 146,
};
exports.mockGetCareerJourneys = {
    success: true,
    careerJourney: [
        {
            uuid: 'ae2319dd-ed5f-4478-ba44-bccc75aab9b1',
            displayName: '',
            description: '',
            duration: 0,
            contentType: 'learningPath',
            level: '',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '302216a6-cc04-40fe-a3c3-b2f4fd147a21',
            displayName: 'Disney Learning Path Celebration!',
            description: 'Disney Learning Path Celebration',
            duration: 160,
            contentType: 'learningPath',
            level: 'basic',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '27379e3e-9cd4-4d19-85ca-8db9ebbf8f78',
            displayName: 'check scorm player 111',
            description: 'A learning path for checking the scorm lessons 111',
            duration: 60,
            contentType: 'learningPath',
            level: 'basic',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '9f1e0083-b31e-4aaa-93c2-4ee8c06b5c82',
            displayName: '',
            description: '',
            duration: 0,
            contentType: 'learningPath',
            level: '',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '4dba27ed-f473-4242-ab3d-c52cfdf037b1',
            displayName: 'C+ Learning Path',
            description: 'C++ ',
            duration: 12,
            contentType: 'learningPath',
            level: 'beginner',
            assignedBy: [],
            userProgress: {
                total: 1,
                notStarted: 0,
                started: 1,
                completed: 0,
            },
        },
        {
            uuid: 'b4d08aa6-bb94-493f-bca5-8b52e39a1d0a',
            displayName: 'Hacking Headlines',
            description: 'Hacking Headlines',
            duration: 54,
            contentType: 'learningPath',
            level: 'beginner',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: 'f2233483-fc61-4ae9-953a-75ff16905490',
            displayName: 'asas',
            description: 'A scorm skill tree',
            duration: 60,
            contentType: 'skillTree',
            level: 'basic',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: 'aee03092-8885-438b-84fa-0b89149d1631',
            displayName: 'Security Champion',
            description: 'Become a Security Champion',
            duration: 342,
            contentType: 'skillTree',
            level: 'Expert',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '84c3c7a2-d4a7-488d-bce4-054d1932e643',
            displayName: 'Test',
            description: 'Skill Tree with C++',
            duration: 318,
            contentType: 'skillTree',
            level: 'basic',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
        {
            uuid: '883198fe-17bb-4ddd-959d-bcba3b686013',
            displayName: 'Test',
            description: 'Skill Tree with C++',
            duration: 234,
            contentType: 'skillTree',
            level: 'basic',
            assignedBy: [],
            userProgress: {
                total: 0,
                notStarted: 0,
                started: 0,
                completed: 0,
            },
        },
    ],
    total: 16,
    unAssignedTotal: 14,
    assignedTotal: 2,
};
exports.mockGetLessonFilters = {
    adminsAndManagers: [{ email: 'email', uuid: 'uuid' }],
    courses: [{ displayName: 'displayName', uuid: 'uuid' }],
    languages: [{ name: 'name', displayName: 'displayName', numLessonsTagged: 5, uuid: 'uuid8' }],
    vulnerabilities: [
        { name: 'name1', displayName: 'displayName1', numLessonsTagged: 5, uuid: 'uuid1' },
        { name: 'name2', displayName: 'displayName2', numLessonsTagged: 1, uuid: 'uuid2' },
        { name: 'name3', displayName: 'displayName3', numLessonsTagged: 2, uuid: 'uuid3' },
        { name: 'name4', displayName: 'displayName4', numLessonsTagged: 3, uuid: 'uuid4' },
        { name: 'name5', displayName: 'displayName5', numLessonsTagged: 4, uuid: 'uuid5' },
        { name: 'name6', displayName: 'displayName6', numLessonsTagged: 5, uuid: 'uuid6' },
        { name: 'name7', displayName: 'displayName7', numLessonsTagged: 6, uuid: 'uuid7' },
    ],
};
var mockGetAssignedContentItems = function (contentType) {
    var result = { success: true, contentDetails: {} };
    switch (contentType) {
        case interfaces_1.ContentType.course:
            result.contentDetails = {
                iconUrl: 'https://picsum.photos/200/300?random=1',
                description: 'Learn how to secure .NET web applications and practice recognizing different attacks.',
                duration: 50,
                items: [
                    {
                        uuid: '6167f220c27d3d842e95299d',
                        displayName: 'Second Order SQL Injection',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '6167f2212479f131a8d55783',
                        displayName: 'SQL Injection',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '6167f21f8df88744cd76a5aa',
                        displayName: 'Command Injection',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '6167f221c27d3d75049529a0',
                        displayName: 'Session Fixation',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '6167f21fc27d3d654b95299a',
                        displayName: 'Cross Site Request Forgery',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '6167f2202479f181f5d55780',
                        displayName: 'Server Side Request Forgery ',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '6167f222c27d3df76c9529a3',
                        displayName: 'Use Of Insufficiently Random Values',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '6167f2218df887102076a5b0',
                        displayName: 'Stored (Persistent) XSS ',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '6167f2208df887508d76a5ad',
                        displayName: 'Reflected XSS',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '6167f2202479f1443ad5577d',
                        displayName: 'Path Traversal',
                        iconUrl: 'https://picsum.photos/200/300?random=1',
                        contentType: 'lesson',
                    },
                ],
            };
            break;
        case interfaces_1.ContentType.skillTree:
            result.contentDetails = {
                description: 'Et lu egu olmu iljerre ipnevzad ani etrofna muhzit geswok zil ronus lo fievu ra po.',
                duration: 132,
                items: [
                    {
                        uuid: 'fbe61106-c601-56e4-a94e-7f09f6de5ddd',
                        displayName: 'Harriet Logan',
                        contentType: 'learningPath',
                    },
                    {
                        uuid: '96b069e5-6837-502e-8cdc-7b3f873e5be8',
                        displayName: 'Addie Huff',
                        contentType: 'learningPath',
                    },
                ],
            };
            break;
        case interfaces_1.ContentType.learningPath:
            result.contentDetails = {
                description: 'Go ez fafbusu mak fogniori vaor carleglaw ujific remzapu mutos hikrojah tomfezag jamgumuz gecafutec.',
                duration: 0,
                items: [
                    {
                        uuid: '80ed22f6-3c57-5ee8-a338-037954ce0ec6',
                        displayName: 'fahbebsik',
                        iconUrl: 'http://nido.ss/vuvnujopa.png',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '4d5e047a-6e16-5cbf-a9f6-e62a291fe3ef',
                        displayName: 'penokfof',
                        iconUrl: 'http://lamahi.pw/da.gif',
                        contentType: 'lesson',
                    },
                    {
                        uuid: '239c63a1-31c4-5394-acab-e0c8abb65fe0',
                        displayName: 'ripetcu',
                        iconUrl: 'http://lefatdum.cw/aj.jpg',
                        contentType: 'course',
                    },
                    {
                        uuid: '75a68038-1567-5e3f-aaf8-39f312699c12',
                        displayName: 'Travis Vargas',
                        contentType: 'challenge',
                    },
                    {
                        uuid: '9d134fa7-c73a-52de-a5a0-2f42aeb25480',
                        displayName: 'Elijah Patton',
                        contentType: 'systemAssessment',
                    },
                ],
            };
            break;
    }
    return result;
};
exports.mockGetAssignedContentItems = mockGetAssignedContentItems;
